import { createSlice } from "@reduxjs/toolkit";

const vehiclesSlice = createSlice({
  name: "vehiclesSlice",
  initialState: {
    items: [],
    options: [],
  },
  reducers: {
    populateData(state, action) {
      state.items = action.payload;
    },
    populateOptions(state, action) {
      const activeVehicles = action.payload.filter((v) => v.active);
      state.options = activeVehicles.map((v) => ({
        label: `${v.licensePlate}, ${v.type}`,
        value: v.id,
      }));
    },
  },
});

export const sliceActions = vehiclesSlice.actions;

export default vehiclesSlice.reducer;
